module.exports = __webpack_public_path__ + "img/attach-file.dd869a4f.svg";